import { merge } from 'lodash';

var styleConstants = {
    borderRadius: '8px',
    colors: {
        primaryColor: '#00A9E0',
        primaryDark: '#002F6C',
        warningColor: '#DF7C1F',
        secondaryColor: '#596794',
        blue: '#228ec2',
        darkBlue: '#243259',
        violet: '#6574a0',
        purple: '#541675',
        red: '#c2224f',
        redError: 'red',
        green: '#18c474',
        grey: '#6a7082',
        grey2: '#E6E8F2',
        orange: '#dc8f15',
        lightGrey: '#F2F2F2',
        white: '#FFF',
        inputBorder: '#CDC9C9'
    }
};
var createAppConstants = function (overrides, customs) {
    return merge(overrides, styleConstants, customs);
};

export { createAppConstants as c, styleConstants as s };
